import User from '@/assets/icons/user.svg';
import { ReturnBackArrowIcon } from '@/components/icons/return-back-arrow';
import { Typography } from '@/components/ui/typography';

interface TargetDetailsProps {
  title: string;
  value: string;
}

export function TargetDetails({ title, value }: TargetDetailsProps) {
  return (
    <div className="flex flex-row gap-4">
      <ReturnBackArrowIcon />
      <div className="flex flex-col gap-1">
        <img src={User} alt="User" className="h-4 w-4" />
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="body1">{value}</Typography>
      </div>
    </div>
  );
}
